import MoveBox from "../../../../content/blog/2020/4/template/move-box.js";
import * as React from 'react';
export default {
  MoveBox,
  React
};